import { baseApi } from '@/admin/baseApi';
import { t } from '@/core/localization';
import { showApiErrorSnackbar } from '@/shared/helpers/thunk';
export const storageApi = baseApi.enhanceEndpoints({ addTagTypes: ['Storage'] }).injectEndpoints({
    endpoints: (builder) => ({
        getStorage: builder.query({
            query: () => ({
                method: 'GET',
                url: 'cellSettings/storageSector',
            }),
            //transformResponse: (response: { 1: IStockListItem[]; 2: IStockListItem[] }) => ({ stock: response[1], transfer: response[2] }),
            providesTags: ['Storage'],
        }),
        getStorageSector: builder.query({
            query: (sectorName) => ({
                method: 'GET',
                url: `cellSettings/storageSector/${sectorName}`,
            }),
            providesTags: ['Storage'],
            onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
                try {
                    await queryFulfilled;
                }
                catch (error) {
                    dispatch(showApiErrorSnackbar({ header: t('get.storage.sector.request.failed'), error }));
                }
            },
        }),
        getOccupiedSectorNames: builder.query({
            query: () => ({
                method: 'GET',
                url: `cellSettings/cell-sectors`,
            }),
            providesTags: ['Storage'],
        }),
        updateStorageSector: builder.mutation({
            query: (body) => ({
                method: 'POST',
                url: `cellSettings/addStorageCell`,
                body,
            }),
            invalidatesTags: () => [{ type: 'Storage' }],
        }),
        deleteStorageSector: builder.mutation({
            query: (body) => ({
                method: 'DELETE',
                url: `cellSettings/deleteStorage`,
                body,
            }),
            invalidatesTags: ['Storage'],
        }),
    }),
});
export const { useGetStorageQuery, useGetStorageSectorQuery, useGetOccupiedSectorNamesQuery, useUpdateStorageSectorMutation, useDeleteStorageSectorMutation, } = storageApi;
